// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-f179b586]{display:none}.bold[data-v-f179b586]{font-weight:var(--font-weight--semibold)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
